'use strict';


export default function(incident) {
	incident.timestamps = {};
	for(var i=0, logLength = incident.log.length; i < logLength; i++) {
		var entry = incident.log[i];
		var event = entry.event;
		if (!incident.timestamps.hasOwnProperty(event)) {
			incident.timestamps[event] = entry;
		} else {
			switch(event) {
				case 'geo:departed':
					incident.timestamps[event] = entry;
					break;
				case 'geo:at_shop':
					incident.timestamps['geo:returned_to_shop'] = entry;
					break;
			}
		}
	}
};
